import React from 'react';
import { Shield, CheckCircle, AlertCircle, FileText, Globe, Search, BarChart3, Layers } from 'lucide-react';

const TOOLS = [
  { href: 'https://gdpriso.com/', icon: <Shield className="w-6 h-6 text-blue-600" />, bg: 'bg-blue-100', title: 'GDPR & ISO 27001', desc: 'Self-assessment tool for dual compliance' },
  { href: 'https://baseline.compliancehub.wiki/', icon: <CheckCircle className="w-6 h-6 text-green-600" />, bg: 'bg-green-100', title: 'Compliance Baseline', desc: 'Establish your security baseline' },
  { href: 'https://airiskassess.com/', icon: <AlertCircle className="w-6 h-6 text-red-600" />, bg: 'bg-red-100', title: 'AI Risk Assessment', desc: 'Evaluate AI system risks' },
  { href: 'https://hipaasecurity.health/', icon: <FileText className="w-6 h-6 text-purple-600" />, bg: 'bg-purple-100', title: 'HIPAA Security', desc: 'Healthcare compliance tools' },
  { href: 'https://www.compliancehub.wiki/', icon: <Globe className="w-6 h-6 text-yellow-600" />, bg: 'bg-yellow-100', title: 'Compliance Hub', desc: 'Central compliance resource' },
  { href: 'https://finemydata.com/', icon: <Search className="w-6 h-6 text-indigo-600" />, bg: 'bg-indigo-100', title: 'Fine My Data', desc: 'Data discovery tools' },
  { href: 'https://estimate.compliancehub.wiki/', icon: <BarChart3 className="w-6 h-6 text-teal-600" />, bg: 'bg-teal-100', title: 'Compliance Estimator', desc: 'Cost and resource planning' },
  { href: 'https://socassessment.com/', icon: <Layers className="w-6 h-6 text-orange-600" />, bg: 'bg-orange-100', title: 'SOC Assessment', desc: 'SOC 2 readiness tools' },
  { href: 'https://cmmcnist.tools/', icon: <Shield className="w-6 h-6 text-gray-600" />, bg: 'bg-gray-100', title: 'CMMC & NIST', desc: 'Defense contractor compliance' },
  { href: 'https://cannabisrisk.diy/', icon: <Shield className="w-6 h-6 text-green-600" />, bg: 'bg-green-100', title: 'Cannabis Risk', desc: 'Industry-specific security tools' },
];

const ToolsShowcase: React.FC = () => (
  <div className="mt-16 pt-8 border-t border-gray-200">
    <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">Explore Our Other Compliance Tools</h2>
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
      {TOOLS.map(({ href, icon, bg, title, desc }) => (
        <a
          key={href}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center p-4 rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all"
        >
          <div className={`w-12 h-12 ${bg} rounded-full flex items-center justify-center mb-3`}>
            {icon}
          </div>
          <h3 className="font-medium text-gray-800 text-center">{title}</h3>
          <p className="text-sm text-gray-600 text-center mt-2">{desc}</p>
        </a>
      ))}
    </div>
  </div>
);

export default ToolsShowcase;
